export default __webpack_public_path__ + "images/7846ab7dee8d8be9f621eceaa55e6a70-EE_SlideDeckBOOK1024_10.png";